import type { UnionTypeLibelle } from "../../../techniques"

export const TypeContratAvenant = [
  'ContratInitial',
  'ContratInitialConjoint',
  'NouveauContratEchec',
  'NouveauContratDefaillanceOf',
  'NouveauContratMaternite',
  'NouveauContratQualificationSuperieure',
  'Avenant',
] as const

export type TypeContratAvenant = typeof TypeContratAvenant[number]

export const TypeContratAvenantLibelles: UnionTypeLibelle<TypeContratAvenant> = {
  ContratInitial: 'Contrat Initial',
  ContratInitialConjoint:
    'Contrat initial conclu conjointement avec deux employeurs pour l’exercice d’une activité saisonnière : une convention tripartite est nécessaire pour la validation du contrat par l’OPCO (contrat régi par l’article L.6325-4-1)',
  NouveauContratEchec: 'Nouveau contrat en raison de l’échec aux épreuves d’évaluation',
  NouveauContratDefaillanceOf: 'Nouveau contrat en raison de la défaillance de l’organisme de formation',
  NouveauContratMaternite: 'Nouveau contrat en raison de la maternité, de la maladie ou d’un accident de travail',
  NouveauContratQualificationSuperieure:
    'Nouveau contrat pour l’obtention d’une qualification supérieure ou complémentaire à celle acquise lors du contrat précédent',
  Avenant: 'Avenant',
} as const
